/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: utils/validators.ts (PIN Lists)
 🗓️ Created: 2025-01-27
 🧩 Description:
    Form validation utilities for PIN Lists.
────────────────────────────────────────────────────────────────*/

import { FormState, PinMember, ValidationErrors, PIN_REGEX } from '../types';

/**
 * Validate PIN List form
 */
export function validatePinListForm(
  formData: FormState,
  members: PinMember[],
  t: (key: string) => string
): ValidationErrors {
  const errors: ValidationErrors = {};
  const trimmedName = formData.name.trim();

  if (trimmedName.length < 3) {
    errors.name = t('pinLists.validation.nameRequired');
  }

  if (!members.length) {
    errors.members = t('pinLists.validation.pinRequired');
  }

  const seenPins = new Set<string>();

  members.forEach((member, index) => {
    const pin = member.pin.trim();

    if (!pin) {
      errors[`member_${index}_pin`] = t('pinLists.validation.pinValueRequired');
      return;
    }

    if (!PIN_REGEX.test(pin)) {
      errors[`member_${index}_pin`] = t('pinLists.validation.invalidPin');
      return;
    }

    const normalized = pin.toLowerCase();

    if (seenPins.has(normalized)) {
      errors[`member_${index}_pin`] = t('pinLists.validation.duplicatePin');
      return;
    }

    seenPins.add(normalized);
  });

  return errors;
}

